document.addEventListener("DOMContentLoaded", function() {
    if (codeItem.length) {
        for (var i = 0; i < codeItem.length; i++) {
            var colorNoavailability = codeItem[i].colorNo;
            var listItemHtml;

            if (colorNoavailability === null) {
                listItemHtml = '<li><a href="/products/' + codeItem[i].itemNo + '"><img src="/cdn/shop/files/' + codeItem[i].itemNo + '_01.jpg"></a></li>';
            } else {
                listItemHtml = '<li><a href="/products/' + codeItem[i].itemNo + '"><img src="/cdn/shop/files/' + codeItem[i].itemNo + '_th_' + codeItem[i].colorNo + '.jpg"></a></li>';
            }

            document.querySelector('.js_is_empty_code_list').insertAdjacentHTML('beforeend', listItemHtml);
        }
    }
});



  // Find all elements with the class 'accordion--color'
const accordions = document.querySelectorAll('.accordion');

// Iterate through each accordion and replace the encoded <br> in the metafield
accordions.forEach(function(accordion) {
  // Find the metafield inside this specific accordion
  const metafield = accordion.querySelector('.metafield-multi_line_text_field');
  
  if (metafield) {
    // Replace &lt;br&gt; with actual <br> tag
    metafield.innerHTML = metafield.innerHTML.replace(/&lt;br&gt;/g, '<br>');
  }
});

window.onload = function() {
  var buyButtons = document.querySelector('[data-block-type="buy-buttons"]');
  const timesactFrag = document.querySelector('.timesact-preorder-description');
  if (buyButtons) {
    if(timesactFrag){
      setTimeout(function() {
        buyButtons.style.opacity = '1';
      }, 1500);  // 2秒後に実行
      console.log('timesact');
    } else {
        buyButtons.style.opacity = '1';
      console.log('timesactじゃない');
    }
  }
};


document.addEventListener("DOMContentLoaded", function () {
  function playVideos(videos) {
    const startPosition = window.scrollY + window.innerHeight;
    videos.forEach(video => {
      const videoPosition = video.getBoundingClientRect().top + window.scrollY;
      if (startPosition > videoPosition) {
        video.play();
        video.loop = true;
      }
    });
  }

  window.addEventListener("load", function () {
    const videos = document.querySelectorAll(".movie__video"); // クラスに合わせる
    if (videos.length > 0) {
      playVideos(videos);
      window.addEventListener("scroll", function () {
        playVideos(videos);
      });
    }
  });

  // `#productVideo` の中に動画がない場合、非表示にする
  const productVideo = document.getElementById("productVideo");
  const videoSource = document.querySelector("#video source");
  
  if (videoSource && videoSource.getAttribute("src").trim() === "") {
    productVideo.style.display = "none";
  }
});

